import { config } from 'env_def';
import moment from 'moment';
import { api } from '@/api/api';
import { apis } from '@/config';
import corpMailUtils from './corp_mail_utils';
import { methodMap } from './mail_action_store_model';
import { getIn18Text } from '@/api/utils';
class AutoReplyApiImpl {
    constructor() {
        this.name = apis.autoReplyApiImpl;
        this.systemApi = api.getSystemApi();
        this.mailConf = api.requireLogicalApi(apis.mailConfApiImpl);
        this.httpApi = api.getDataTransApi();
        this.DataStore = api.getDataStoreApi();
    }
    buildUrl(key, additionalParam) {
        var _a;
        const sid = ((_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.sessionId) || '';
        if (!sid) {
            return config('notExistUrl');
        }
        const isCorpMailModeUser = this.systemApi.getIsCorpMailMode();
        if (isCorpMailModeUser) {
            const params = Object.assign({ sid }, (additionalParam || {}));
            const url = corpMailUtils.getUrlByMailFuncName(key);
            return this.httpApi.buildUrl(url, params);
        }
        let req = {
            func: methodMap[key],
            sid,
        };
        if (additionalParam) {
            req = Object.assign(req, additionalParam);
        }
        return this.httpApi.buildUrl(this.systemApi.getUrl('mailOperation'), req);
    }
    init() {
        return this.name;
    }
    async getMailRulesByAutoReply() {
        const url = this.buildUrl('getMailClassifyRule');
        const data = this.httpApi
            .post(url, { category: 'autoreply' }, { contentType: 'json' })
            .then((res) => {
            if (res.data.code === 'S_OK') {
                if (res.data.var.length > 0) {
                    return AutoReplyApiImpl.setAutoReplyModelByRules(res.data.var[0]);
                }
                return this.getLocalStore();
            }
            return AutoReplyApiImpl.getDefaultAutoReply();
        })
            .catch(err => {
            console.log('getMailRulesByAutoReply=failed', err);
            return this.getLocalStore();
        });
        return data;
    }
    static setAutoReplyModelByRules(res) {
        var _a, _b;
        const autoReply = AutoReplyApiImpl.getDefaultAutoReply();
        if (Object.keys(res).length > 0) {
            autoReply.disabled = false;
        }
        autoReply.id = res.id ? res.id : null;
        if (((_a = res === null || res === void 0 ? void 0 : res.condictions) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            let start = null;
            let end = null;
            if (typeof res.condictions[0].operand === 'string') {
                start = res.condictions[0].operand;
            }
            else {
                [start, end] = res.condictions[0].operand;
            }
            const startMoment = start ? moment(start).second(0).millisecond(0) : null;
            const endMoment = end ? moment(end).second(0).millisecond(0) : null;
            const moments = {
                startDate: startMoment,
                startTime: startMoment,
                endDate: endMoment,
                endTime: endMoment,
            };
            autoReply.moments = moments;
        }
        if (((_b = res === null || res === void 0 ? void 0 : res.actions) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            const { content, onlyContact, onceForSameSender } = res.actions[0];
            autoReply.content = content;
            autoReply.onlyContact = onlyContact;
            autoReply.onceForSameSender = onceForSameSender;
        }
        console.log('autoReply=====', autoReply);
        return autoReply;
    }
    async addMailRulesByAutoReply(form) {
        const items = AutoReplyApiImpl.translateJson(form);
        const url = this.buildUrl('addMailClassifyRule');
        const result = this.httpApi
            .post(url, { items, category: 'autoreply' }, { contentType: 'json' })
            .then(res => {
            var _a, _b;
            if (((_a = res.data) === null || _a === void 0 ? void 0 : _a.code) === 'S_OK') {
                this.setLocalStore(Object.assign(Object.assign({}, form), { id: null }));
                return (_b = res.data) === null || _b === void 0 ? void 0 : _b.var[0];
            }
            return null;
        });
        return result;
    }
    async updateMailRulesByAutoReply(form) {
        const items = AutoReplyApiImpl.translateJson(form);
        const url = this.buildUrl('editMailClassifyRule');
        const result = this.httpApi
            .post(url, { items, category: 'autoreply' }, { contentType: 'json' })
            .then(res => {
            var _a;
            if (((_a = res.data) === null || _a === void 0 ? void 0 : _a.code) === 'S_OK') {
                this.setLocalStore(Object.assign(Object.assign({}, form), { id: null }));
                return true;
            }
            return false;
        });
        return result;
    }
    getLocalStore() {
        const sync = this.DataStore.getSync(AutoReplyApiImpl.storeName);
        if (sync && sync.suc && sync.data) {
            const data = JSON.parse(sync.data);
            data.disabled = true;
            const { startDate, endDate, startTime, endTime } = data.moments;
            data.moments = {
                startDate: startDate ? moment(startDate) : null,
                endDate: endDate ? moment(endDate) : null,
                startTime: startTime ? moment(startTime) : null,
                endTime: endTime ? moment(endTime) : null,
            };
            return data;
        }
        return AutoReplyApiImpl.getDefaultAutoReply();
    }
    setLocalStore(form) {
        this.DataStore.putSync(AutoReplyApiImpl.storeName, JSON.stringify(form));
    }
    static translateJson(form) {
        const { id, content, disabled, moments, onceForSameSender, onlyContact } = form;
        const { startTime, endTime } = moments;
        const item = {
            id,
            name: 'autoReply',
            disabled,
            continue: true,
            actions: [
                {
                    type: 'reply',
                    content,
                    onlyContact,
                    onceForSameSender,
                },
            ],
            condictions: [
                {
                    field: 'receivedDate',
                    disabled,
                    operand: moment.isMoment(endTime) ? [moment(startTime).valueOf(), moment(endTime).valueOf()] : moment(startTime).valueOf(),
                    operator: startTime && endTime ? 'between' : 'gt',
                },
            ],
        };
        return [item];
    }
    static translateXml(form) {
        const { id, content, disabled, moments } = form;
        const { startTime, endTime } = moments;
        const contentStr = AutoReplyApiImpl.html2Escape(content);
        console.log('contentStr', contentStr);
        const result = `<?xml version="1.0"?>
      <object>
        <string name="category">autoreply</string>
        <array name="items">
          <object>
            <string name="name">autoReply</string>
            <boolean name="disabled">${disabled}</boolean>
            <boolean name="continue">true</boolean>
            <array name="condictions">
              <object>
                <string name="field">receivedDate</string>
                <boolean name="disabled">${disabled}</boolean>
                <string name="operator">${startTime && endTime ? 'between' : '&gt;'}</string>
                ${moment.isMoment(endTime)
            ? `
                <array name="operand">
                <date>${moment(startTime).format('YYYY-MM-DD HH:mm:ss')}</date>
                <date>${moment(endTime).format('YYYY-MM-DD HH:mm:ss')}</date>
                </array> 
                `
            : `
                <date name="operand">${moment(startTime).format('YYYY-MM-DD HH:mm:ss')}</date>
                `}
              </object>
            </array>
            <array name="actions">
              <object>
                <string name="type">reply</string>
                <boolean name="disabled">false</boolean>
                <string name="content">${contentStr}</string>
              </object>
            </array>
            ${id ? `<int name="id">${id}</int>` : ''}
          </object>
        </array>
      </object>`;
        return result;
    }
    static html2Escape(sHtml) {
        return sHtml.replace(/[<>&"]/g, c => AutoReplyApiImpl.map[c]);
    }
}
AutoReplyApiImpl.map = {
    '<': '<',
    '>': '>',
    '&': '&',
    '"': '"',
};
AutoReplyApiImpl.storeName = 'AutoReplyInfo';
AutoReplyApiImpl.initMomentsState = () => {
    const cur = moment();
    cur.second(0).millisecond(0);
    let minutes = cur.minutes();
    minutes = Math.ceil(minutes / 15) * 15;
    cur.minutes(minutes);
    const moments = {
        startDate: cur,
        startTime: cur.clone(),
        endDate: null,
        endTime: null,
    };
    return moments;
};
AutoReplyApiImpl.getDefaultAutoReply = () => {
    const autoReply = {
        disabled: true,
        id: null,
        content: getIn18Text('NINHAO，NINDEYOUJIAN'),
        onlyContact: false,
        onceForSameSender: false,
        moments: AutoReplyApiImpl.initMomentsState(),
    };
    return autoReply;
};
const autoReplyApiImpl = new AutoReplyApiImpl();
api.registerLogicalApi(autoReplyApiImpl);
export default autoReplyApiImpl;
